import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

// Rounded custom bar with dynamic color
const CustomBar = ({ x, y, width, height, payload }) => (
  <g>
    <rect
      x={x}
      y={y}
      width={width}
      height={height}
      rx={10}
      ry={10}
      fill={payload.fill}
    />
  </g>
);

// Function to map API data to chart format with colors
const mapChartData = (inputData = []) => {
  const colors = [
    "#6a0dad",
    "#00a86b",
    "#ff8c00",
    "#1e90ff",
    "#ff1493",
    "#007bff",
    "#28a745",
    "#dc3545",
    "#ffc107",
    "#6610f2",
  ];

  return inputData.map((item, index) => ({
    name: item.hour_range,
    vehicles: item.vehicle_count,
    fill: colors[index % colors.length],
  }));
};

const PeakHoursChart = ({ data }) => {
  const chartData = mapChartData(data);

  return (
    <div
      style={{
        height: "400px",
        alignItems: "center",
        background: "#FFF",
        padding: "50px 30px",
        borderRadius: "15px",
        border: "1px solid #CDCDCD",
        boxShadow: "2px 4px 5px #DDD",
      }}
    >
      <h5 style={{ marginBottom: "20px" }}>Peak Hours</h5>
      <hr />
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={chartData}
          margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
        >
          <XAxis
            dataKey="name"
            label={{
              value: "Time Interval",
              position: "insideBottom",
              dy: 10,
            }}
          />
          <YAxis
            label={{ value: "Vehicles", angle: -90, position: "insideLeft" }}
          />
          <Tooltip />
          <Bar
            dataKey="vehicles"
            shape={<CustomBar />}
            background={{ fill: "#f3f6fc" }}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PeakHoursChart;
